// Module Federation runtime loader (§7.1). The host registers workspace MFE
// remotes dynamically from workspaces.json and lazy-loads them by route.

import {
  init,
  loadRemote as enhancedLoadRemote,
  preloadRemote,
  registerRemotes,
} from '@module-federation/enhanced/runtime';
import { config } from '../../config';

let registered = false;

function resolveUrl(remoteUrl: string): string {
  if (remoteUrl.startsWith('http://') || remoteUrl.startsWith('https://')) return remoteUrl;
  const base =
    config.baseUrl && /^https?:\/\//.test(config.baseUrl) ? config.baseUrl : window.location.origin;
  return new URL(remoteUrl, base).toString();
}

/** Register all workspace remotes once at boot. */
export function initWorkspaceRemotes(): void {
  if (registered) return;
  registered = true;

  const remotes = config.workspacesConfig.remotes.map(r => ({
    name: r.id,
    entry: resolveUrl(r.url),
  }));

  init({ name: 'gaxl_web_host', remotes: [] });
  registerRemotes(remotes);

  // Best-effort preload; failures are tolerated (a workspace MFE may be down in
  // local dev). The WorkspaceOutlet handles per-remote load errors at render.
  void preloadRemote(
    config.workspacesConfig.remotes.map(r => ({
      nameOrAlias: r.id,
      // Expose keys are `./Name` in webpack ModuleFederationPlugin.
      exposes: [`./${r.exposedModule}`],
      prefetchInterface: true,
    }))
  ).catch(err => console.warn('[mf] workspace preload failed', err));
}

export async function loadWorkspaceRemote(
  remoteId: string,
  exposedModule: string
): Promise<{ default: React.ComponentType<unknown> }> {
  const factory = await enhancedLoadRemote(`${remoteId}/${exposedModule}`);
  return factory as { default: React.ComponentType<unknown> };
}
